package com.fireavert.properties.shared.data_models.responses

import com.fireavert.reports_page.shared.data_models.EventTypes
import kotlinx.serialization.Serializable

@Serializable
data class PropertySensorTypeResponse(
    var sensorTypes: List<EventTypes>
)
